//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { useSelector } from 'react-redux';

import { useCurrentStateAndParams } from '@hooks/useCurrentStateAndParams';
import { MediaTrackingSource } from '@tracker/mediaTracking/mediaTrackingModel';
import { getLaunchOptions } from '@uia/redux/uiaSelector';
import { isDefined } from '@utils/filterPredicates';

import { RoutableStateName } from 'app/top-level-states';

export const useGetMediaTrackingSource = () => {
  const {
    state,
  }: {
    state: RoutableStateName;
  } = useCurrentStateAndParams();

  const launchOptions = useSelector(getLaunchOptions);

  if (isDefined(launchOptions?.trackingConfig?.source)) {
    return launchOptions.trackingConfig.source;
  }

  switch (state) {
    case 'influencers.user-media':
      return MediaTrackingSource.INFLUENCER_DETAILS_PAGE;

    case 'influencers.list':
      return MediaTrackingSource.INFLUENCERS_LIST_MEDIA_PAGE;

    case 'instagramAccount.hashtagInsights.recent-content':
      return MediaTrackingSource.INSTAGRAM_HASHTAG_PAGE;

    case 'sampling':
    case 'sampling.campaign-details':
    case 'sampling.campaign-type':
      return MediaTrackingSource.CAMPAIGNS_PAGE;

    case 'instagramAccount.mentionedAndTagged':
      return MediaTrackingSource.INSTAGRAM_MENTIONED_AND_TAGGED_PAGE;

    default:
      return MediaTrackingSource.NO_SOURCE;
  }
};
